export default __webpack_public_path__ + "static/pattern1-8738fbaafcffb3ce82b477e40eabd00f.png";